import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/initialize';

import buildUrl from 'build-url';
import moment from 'moment-timezone';
import drupalSettings from 'drupalSettings';
import Drupal from 'Drupal';
import {DebounceInput} from 'react-debounce-input';
import ReactPaginate from 'react-paginate';
import { DateRangePicker } from 'react-dates';
import withSessionStorage from './session-storage/withSessionStorage';

import 'moment/locale/en-ca';
import 'moment/locale/fr';

if (drupalSettings.path.currentLanguage === 'en') {
  moment.locale('en');
} else {
  moment.locale('fr');
}

let API_URL = '/api/events';
if (drupalSettings.path.currentLanguage === 'fr') {
  API_URL = '/fr/api/events';
}

const Icon = (props) => {
  return <svg className="icon">
    <use xlinkHref={ '#' + props.name }></use>
  </svg>;
}

class Event extends Component {
  render() {
    return (
      <a className="events-list-box" href={this.props.event.link}>
        <div className="events-list-time">
          <div>{(drupalSettings.path.currentLanguage === 'en') ? this.props.event.start.format('h:mm A') : this.props.event.start.format('H[h]mm') }</div>
          <svg version="1.1" viewBox="0 0 1 7" xmlns="http://www.w3.org/2000/svg" className="events-list-time-dash"><g fill="none" fillRule="evenodd" strokeLinecap="square"><g transform="translate(-49 -37)" stroke="#B7B7B7"><path d="m49.5 37.5v6"/></g></g></svg>
          <div>{(drupalSettings.path.currentLanguage === 'en') ? this.props.event.end.format('h:mm A') : this.props.event.end.format('H[h]mm') }</div>
        </div>

        <div className="events-list-link-box w-inline-block">
          <div>
            <h4 className="events-list-event-name" dangerouslySetInnerHTML={{__html:this.props.event.name}}></h4>
            <h5 className="events-list-location" dangerouslySetInnerHTML={{__html:this.props.event.location}}></h5>
          </div>
          <svg width="14px" height="24px" viewBox="0 0 14 24" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g transform="translate(-701.000000, -30.000000)" fill="#BEBFC1" fillRule="nonzero"><path d="M703.206875,53.207125 L701.792875,51.793125 L711.792875,41.793125 L701.792875,31.793125 L703.206875,30.379125 L713.913875,41.086125 C714.304875,41.477125 714.304875,42.109125 713.913875,42.500125 L703.206875,53.207125 Z"></path></g></g></svg>
        </div>
      </a>
    )
  }
}

class EventGroup extends React.Component {
  render() {
    return (
      <div className="events-list-day-container">
        {(drupalSettings.path.currentLanguage === 'en' ? <h3 className="events-list-date">{this.props.events.date.format('MMMM D, YYYY')}</h3> : <h3 className="events-list-date">{this.props.events.date.format('D MMMM YYYY')}</h3> )}
        {this.props.events.events.map(function(event, index) {
          return <Event event={event} key={index}></Event>;
        })}
      </div>
    )
  }
}

class Events extends React.Component {
  constructor(props) {
    super(props);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.clearAll = this.clearAll.bind(this);
    this.state = {
      locale: drupalSettings.path.currentLanguage,
      events: [],
      search: '',
      page: 0,
      pageCount: 0,
      selectedCategories: [],
      categories: drupalSettings.events.categories,
      showLoadMore: false,
      loading: true,
      hasFilters: false,
      startDate: null,
      endDate: null,
      focusedInput: null
    };

    this.eventRef = null;
  }

  buildUrl() {
    var query = {
      'page': this.state.page,
      '_format': 'json',
      'langcode': (drupalSettings.path.currentLanguage === 'en') ? 'en' : 'fr'
    };

    if (this.state.search !== '') {
      query.search = this.state.search
    }

    if (this.state.startDate && this.state.endDate) {
      query['field_event_start_date_and_time_value[min]'] = '@' + this.state.startDate.tz('America/Halifax').startOf('day').unix()
      query['field_event_start_date_and_time_value[max]'] = '@' + this.state.endDate.tz('America/Halifax').endOf('day').unix()
    } else {
      query['field_event_start_date_and_time_value[min]'] = '@' + moment().tz('America/Halifax').unix()
      query['field_event_start_date_and_time_value[max]'] = '@' + moment().tz('America/Halifax').add(1,'year').unix()
    }

    if (this.state.selectedCategories.length !== 0) {
      query['field_category_target_id[]'] = [];
      for (var index = 0; index < this.state.selectedCategories.length; index++) {
        query['field_category_target_id[]'].push(this.state.selectedCategories[index])
      }
    }

    if (this.state.search !== '' || this.state.selectedCategories.length !== 0 || (this.state.startDate && this.state.endDate)) {
      this.setState({hasFilters: true})
    } else {
      this.setState({hasFilters: false})
    }

    var url = buildUrl(API_URL, {
      disableCSV: true,
      queryParams: query
    });

    return url
  }

  _addEventFromApi(event) {
    const regex = /<time .*?>(\d+)<\/time>/;
    let match = event.start.match(regex);
    let timestamp = parseInt(match[1], 10);

    // Find group it belongs to
    var start = moment.unix(timestamp).tz('America/Halifax');
    var _start = moment.unix(timestamp).tz('America/Halifax');
    match = event.end.match(regex);
    timestamp = parseInt(match[1], 10);
    var end = moment.unix(timestamp).tz('America/Halifax');

    var exists = false;
    var events = this.state.events

    events.forEach((item) => {
      if (start.isSame(item.date, 'day')) {
        exists = true;

        item.events.push({
          name: event.title,
          location: event.field_event_location_organization,
          start: start,
          end: end,
          link: event.view_node
        })
      }
    });

    if (exists === false) {
      events.push({
        date: _start.hour(0).minute(0).second(0),
        events: [
          {
            name: event.title,
            location: event.field_event_location_organization,
            start: start,
            end: end,
            link: event.view_node
          }
        ]
      })
    }

    this.setState({events: events})
  }

  componentDidMount() {
    let localState = this.props.getStateFromSessionStorage(this);

    if (localState && localState.startDate) {
      localState.startDate = moment(localState.startDate).tz('America/Halifax')
      localState.endDate = moment(localState.endDate).tz('America/Halifax')
    }

    this.setState(localState, () => {
      this.updateEvents(true)
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  focusTo() {
    // Focus to `to` field. A timeout is required here because the overlays
    // already set timeouts to work well with input fields
    this.timeout = setTimeout(() => this.to.getInput().focus(), 0);
  }

  showFromMonth() {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).tz('America/Halifax').diff(moment(from).tz('America/Halifax'), 'months') < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  }

  updateEvents(clear, scroll) {
    var url = this.buildUrl()

    if (clear) {
      this.setState({events: []})
    }

    this.setState({loading: true})

    fetch(url)
      .then(response => response.json())
      .then(data => {
        data.results.forEach((event) => {
          this._addEventFromApi(event)
        })

        this.setState({
          pageCount: data.pager.pages,
          loading: false
        })
      })

    if (scroll === true) {
      window.scrollTo(0, this.eventRef.offsetTop)
    }
  }

  handleTitleChange(event) {
    this.setState({
      search: event.target.value,
      page: 0
    }, () => {
        this.updateEvents(true)
    });
  }

  handleLoadMore(page) {
    this.setState(
      { page: (page.selected) ? parseInt(page.selected) : 0 },
      () => {
        this.updateEvents(true, true)
      }
    );
  }

  handleCategorySelect(tid) {
    var categories = this.state.selectedCategories;

    if (categories.includes(tid)) {
      categories.splice(categories.indexOf(tid), 1)
    } else {
      categories.push(tid)
    }

    this.setState(
      {
        selectedCategories: categories,
        page: 0
      },
      () => {
        this.updateEvents(true)
      }
    )
  }

  clearAll() {
    this.setState(
      {
        startDate: null,
        endDate: null,
        search: '',
        selectedCategories: [],
        loading: true,
        page: 0
      },
      () => {
        this.updateEvents(true)
      }
    );
  }

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    const smallDevice = window.matchMedia('(max-width: 600px)').matches;
    const numberOfMonths = smallDevice ? 1 : 2;
    return (
      <div className="section-events-list" ref={(ref) => this.eventRef = ref}>
        <div className="blue-heading-block-short">
          <div className="blue-heading-container">
            <h2 className="blue-heading-header">{Drupal.t('Events')}</h2>
            <div className="section-search w-form">
              <DebounceInput
                minLength={2}
                debounceTimeout={500}
                className="section-search-input w-input"
                maxLength="256"
                name="query"
                placeholder={Drupal.t('Search')}
                id="section-search"
                type="search"
                value={this.state.search}
                onChange={this.handleTitleChange} />
            </div>
          </div>
        </div>
        <div className="events-list-container">
          <div className="events-list-left-column">
            { (this.state.loading !== true && this.state.hasFilters)  ? <div><a className="clear-all" onClick={this.clearAll}>{Drupal.t('Clear All')}</a></div> : null }
            {this.state.events.map(function(event, index) {
              return <EventGroup events={event} key={index}></EventGroup>;
            })}

            {(this.state.events.length === 0 && this.state.loading === false) ? <div className="no-results-found">{Drupal.t('No results found.')}</div> : null}

            { (this.state.loading === true) ? <div className="loading"><svg width="70px" height="70px" viewBox="140 -1 68 70" version="1.1" id="SJN_PHYhsG"><g id="rkHuwrY2jG" fillRule="evenodd"><g id="HJUuvrK3sf"><g id="rJPdPBFnoM_HkudSK2oz"><path d="M0.1640625,28.1757812 C5.79354297,33.2055813 11.3312056,35.7432439 16.7770503,35.788769 C22.222895,35.8342942 27.6687397,33.3884495 33.1145845,28.4512349 C39.1033043,33.9747803 44.909886,36.781362 50.5343296,36.87098 C56.1587732,36.960598 61.7832168,34.3361544 67.4076604,28.9976492 C73.8347605,35.0245907 79.9290891,38.1189193 85.6906461,38.280635 C91.4522032,38.4423507 97.2137602,35.6807936 102.975317,29.9959639 C109.444473,35.7527492 115.437072,38.7453478 120.953113,38.9737596 C126.469154,39.2021713 131.985196,36.6861299 137.501237,31.4256352 C143.143013,36.0387188 148.515214,38.4109199 153.617841,38.5422385 C158.720467,38.6735571 163.823093,36.5709309 168.925719,32.2343598 C174.985169,37.9062501 180.86526,40.7863407 186.565991,40.8746315 C192.266722,40.9629222 197.967453,38.2621911 203.668184,32.7724381 C209.227767,37.9814772 214.823277,40.5769865 220.454712,40.5589659 C226.086148,40.5409454 231.717583,37.9095099 237.349018,32.6646595 C243.480762,39.422327 249.809573,42.7511384 256.335453,42.6510937 C262.861332,42.5510491 269.387212,39.0251696 275.913091,32.0734552 C281.933116,37.6303339 287.759216,40.4564339 293.391391,40.5517552 C299.023567,40.6470765 304.655742,38.0149012 310.287917,32.6552291 C316.005362,38.9498739 322.064831,42.0093431 328.466325,41.8336367 C334.867819,41.6579303 341.269313,38.2564362 347.670807,31.6291543 C353.197442,36.7591832 358.754763,39.3165046 364.342772,39.3011187 C369.930781,39.2857328 375.518789,36.697724 381.106798,31.5370922" id="rJPdPBFnoM"/></g><circle id="HkuuPrFnoG" cx="173.5" cy="33.5" r="33.5"/></g></g></svg></div> : null }

            {this.state.pageCount > 1 ?
              <ReactPaginate
                previousLabel={'previous'}
                nextLabel={'next'}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={this.state.pageCount}
                marginPagesDisplayed={0}
                pageRangeDisplayed={3}
                onPageChange={this.handleLoadMore}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                initialPage={this.state.page}
                forcePage={this.state.page}
                disableInitialCallback={true}
              />
            : null }
          </div>
          <div className="events-list-right-column">
            <h3 className="events-list-filters">{Drupal.t('Categories')}</h3>
            <div className="events-list-categories">
            {this.state.categories.map((category) => {
              return <div className={"events-list-category-button w-button " + (this.state.selectedCategories.includes(category.tid) ? 'active' : '')} key={category.tid} onClick={() => this.handleCategorySelect(category.tid)}><Icon name={category.icon}></Icon>{category.name}</div>;
            })}
            </div>
            <h3 className="events-list-filters">{Drupal.t('Sort by Date')}</h3>
            <div className="w-form date-picker">
              <DateRangePicker
                startDate={this.state.startDate}
                startDateId="events_start_date"
                endDate={this.state.endDate}
                endDateId="events_end_date"
                onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate }, () => {

                  if (startDate && endDate){
                    this.setState({page: 0}, () => this.updateEvents(true))
                  }
                })}
                focusedInput={this.state.focusedInput}
                onFocusChange={focusedInput => this.setState({ focusedInput })}
                hideKeyboardShortcutsPanel={true}
                minimumNights={0}
                startDatePlaceholderText={drupalSettings.path.currentLanguage === 'en' ? "Start Date" :"Arrivée"}
                endDatePlaceholderText={drupalSettings.path.currentLanguage === 'en' ? "End Date" : "Départ"}
                numberOfMonths={numberOfMonths}
              />
            </div>
          </div>
        </div>
        <div className="events-list-grey"></div>
      </div>
    )
  }
}

Events.sessionStorageKeys = ['startDate', 'endDate', 'page', 'search', 'selectedCategories'];
Events.sessionStorageNamespace = 'events';

Events = withSessionStorage(Events);

export default Events;
